import { AxiosResponse } from "axios";
import { ApiBaseUrl, AuthUrl, request } from "shared/clients/baseClient";
import { snakizeObject } from "shared/helpers/object";

const clientId = import.meta.env.VITE_DATA_ROOM_CLIENT_ID;
const clientSecret = import.meta.env.VITE_DATA_ROOM_CLIENT_SECRET;

// TODO: add types
const loginWithEmailAndPassword = (data: {
  username: string;
  password: string;
}): Promise<{ data: { access_token: string } }> => {
  const mappedData = {
    ...data,
    grantType: "password",
    clientId,
    clientSecret,
  };

  return request({
    authenticate: false,
    options: {
      url: `${AuthUrl}/token/`,
      method: "POST",
      data: snakizeObject(mappedData),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Cache-Control': 'max-age=0',
        'Content-Security-Policy': 'default-src \'self\'; img-src https://*; child-src \'none\';',
        'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'SAMEORIGIN',
        'Referrer-Policy': 'strict-origin-when-cross-origin',
      },
    },
  });
};

const getMe = (): Promise<AxiosResponse<any>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/user/me`,
      method: "GET",
    },
  }).then((data: AxiosResponse<any>) => ({
    ...data,
  }));
};

export const usersClient = {
  loginWithEmailAndPassword,
  getMe,
};
